import React from 'react';

import { Box, Slide, Typography } from '@mui/material';

const Credits = () => {
  const getCredit = (title: string, name: string) => {
    return (
      <>
        <Typography variant='h4' component='div' mt={4}>
          {title}
        </Typography>
        <Typography
          variant='body1'
          component='div'
          mt={1}
          sx={{ color: 'orange' }}
        >
          {name}
        </Typography>
      </>
    );
  };

  return (
    <Box mt={2} mx={2}>
      <Typography variant='h1' component='div'>
        Credits
      </Typography>
      <Box sx={{ maxHeight: '700px', overflow: 'hidden', textAlign: 'center' }}>
        <Slide
          in={true}
          direction='up'
          timeout={{
            appear: 1000,
            enter: 5000,
            exit: 500,
          }}
        >
          <div>
            {getCredit('Infrastructure', '@SpookyCookie @Kagge')}
            {getCredit('Mobile App & Game API', '@Kagge')}
            {getCredit('IntelSite API & Front End', '@SpookyCookie')}
            {getCredit('Bot', '@Benjamin - celien')}
            {getCredit('IntelSite Icons & UX Ideas', '@ax|om')}
            {getCredit('WarPlanner UX Concept', '@Brotality')}
          </div>
        </Slide>
      </Box>
    </Box>
  );
};

export default Credits;
